/**
 * Netcode tunables (BUILD_PLAN section 8 with DECISIONS.md #16): one input per tick, snapshots
 * every tick, the opponent drawn 100 ms behind, 500 ms of hitbox history, a 30 s reconnection
 * grace. Everything here is a default the server may override from its environment.
 */
import { SIM_TICK_RATE } from '../constants.js';
export const NET = {
    /** How far behind the newest received tick the opponent is drawn. */
    INTERP_DELAY_TICKS: 3,
    /** Furthest the timeline extrapolates when snapshots are late. */
    MAX_EXTRAPOLATION_TICKS: 2,
    /** Pose history the server keeps for lag compensation (500 ms). */
    /** Snapshots carry the state hash every this many ticks (and always with a full state). */
    HASH_EVERY_TICKS: 10,
    HISTORY_TICKS: 15,
    MIN_LEAD_TICKS: 1,
    MAX_LEAD_TICKS: 12,
    /** Inputs for ticks this far behind the server are dropped as late. */
    MAX_INPUT_BEHIND_TICKS: 30,
    /** Authoritative states the client keeps for interpolation and resync checks. */
    CLIENT_RING_TICKS: 64,
    /** Pending (unacknowledged) inputs kept on the client before it re-anchors. */
    MAX_PENDING_INPUTS: 40,
    /** A correction above this snaps the view instead of easing it. */
    SNAP_CORRECTION_M: 2,
    CORRECTION_HALF_LIFE_MS: 60,
    /** Corrections within this many ticks of an authoritative hit or crowd control on the own mech are expected. */
    EXPECTED_CORRECTION_TICKS: 15,
    /** Input packets per second above which a client is flagged and kicked. */
    MAX_PACKETS_PER_SECOND: 45,
    /** Colyseus' own message limit, kept above the packet check so the room kicks first. */
    MESSAGE_FLOOD_PER_SECOND: 120,
    /** Control messages (hello, resync) per second above which a client is kicked (Phase 9). */
    MAX_CONTROL_PER_SECOND: 5,
    /** A resync earns a full state at most this often per seat (Phase 9). */
    RESYNC_MIN_MS: 1000,
    /** Malformed messages in one room before the client is kicked; no honest client sends any (Phase 9). */
    MAX_MALFORMED_MESSAGES: 30,
    RECONNECT_GRACE_SECONDS: 30,
    JOIN_TIMEOUT_SECONDS: 60,
    READY_TIMEOUT_SECONDS: 60,
    /** Disconnections per player per match before the next one forfeits at once. */
    MAX_RECONNECTIONS: 2,
    /** How long a finished room lingers so both clients receive the result. */
    LINGER_SECONDS: 10,
};
export const TICK_MS = 1000 / SIM_TICK_RATE;
//# sourceMappingURL=constants.js.map